import React from 'react';
import {useState, useEffect, useRef} from 'react';
import {Modal, Button, Form} from 'react-bootstrap';
import DatePicker from 'react-datepicker';
//import 'react-datepicker/dist/react-datepicker.css';
import { format } from 'date-fns';
import { Bar, Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

import api from '../conexao.js';
import '../relatorios/table.css';
import logOut from '../logOut';

import pdfMake, { fonts } from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
import './impAgenda.css'

// Registra os componentes do Chart.js que serão utilizados
ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

export default function ImpAgenda(){

    const [mostraRel, setMostraRel] = useState(false);
    const [medicos, setMedicos] = useState([]);
    const [codMed, setCodMed] = useState();
    const [data1, setData1] = useState();
    const [data2, setData2] = useState();
    const [opcao, setOpcao] = useState(0);
    const [disableBtn, setDisableBtn] = useState(true);
    const [MSG, setMSG] = useState();
    const [modalMSG, setModalMSG] = useState(false);
    var vt = 0;

    
    const [agenda, setAgenda] = useState([]);

    const impAgenda = useRef(null)

 

    useEffect( () => {   

        async   function buscaMedicos() {
       
             await  api.get('/medico',{params:{
                nome: '%'
             }}).then(listamedicos => {   
                   setMedicos(listamedicos.data)
                   if (listamedicos.data && listamedicos.data.length > 0) {
                       setCodMed(listamedicos.data[0].CODIGO)
                   }
       
               }).catch((error) => {
                setDisableBtn(true)
                setMSG(logOut(error))
                setModalMSG(true)
            })
           }
           buscaMedicos();
           setDisableBtn(true)
       },[]);  

    function transformaData(d){

        var date = d.replace('T03:00:00.000Z','');
        date = date.split('-').reverse().join('/');   
        return(date)
    }   

    async function handleBuscaAgenda() {
        setAgenda([]); // Limpa os dados anteriores
        setDisableBtn(true);
        if (data1 && data2) {
            const params = {
                cod_medico: codMed,
                data1: format(data1, 'yyyy-MM-dd'),
                data2: format(data2, 'yyyy-MM-dd'),
            };

            if (opcao != 0) {
                params.cod_status = opcao;
            }
            
            await api.get('relimpagenda', { params })
            .then (result => {
                // console.log(result.data)
                setAgenda(result.data)
                
                if (!result.data || result.data.length === 0) {
                    setMSG('Não existem consultas nesse intervalo de data!');
                    setModalMSG(true)
                } else {
                    setDisableBtn(false);
                }
            }).catch((error) => {
                setDisableBtn(true)
                setMSG(logOut(error))
                setModalMSG(true)
            })
        
        } else {
            setMSG('Preencha as Datas!');
            setModalMSG(true) 
        }       
    }

    function handleNomeMedico(){
        if (!medicos || medicos.length === 0 || !codMed) return '';
        var nomeMed = medicos.find(m => m.CODIGO == parseInt(codMed) );
        return nomeMed ? nomeMed.NOME : '';
    }

    function valorTotal(ag){
        var valort = 0;
     
        for (let a = 0; a < ag.length; a++) {
            valort = valort + (ag[a].VALOR || 0);
        }
        vt = valort;
        return(valort)
    }
    
    const PrintReports = (reports) => {
        pdfMake.vfs = pdfFonts.pdfMake.vfs;

        let nomeMed = handleNomeMedico()

        const globalStyle = {// Define a fonte
            fontSize: 12, // Define o tamanho da fonte padrão
            color: 'black', // Define a cor do texto padrão
        };
          
        const infoSub = [
            {text: `Médico: ${nomeMed}`, style: 'subheader'}
        ];

        const infoDate = [
            {text: `De: ${format(data1,'dd/MM/yyyy')}   Até: ${format(data2,'dd/MM/yyyy')}`, style: 'subheader'}
        ]; 

        const reportTitle = [
            {
              text: 'Agenda',
              style: 'header'
            },
        ];
      
        const dados = reports.map((report) => {
     
            let date = transformaData(report.DATA)

            // Retornando os agendamentos
            if (report.VALOR) {
                report.VALOR = parseInt(report.VALOR).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}).toString();
            } else {
                report.VALOR = 'R$ 0,00'
            }
            return [
                {text: date, fontSize: 9, margin: [0, 5]},
                {text: report.HORA, fontSize: 9, margin: [0, 5]},
                {text: report.Paciente.NOME, fontSize: 9, margin: [0, 5]},
                {text: report.Status.DESCRICAO, fontSize: 9, margin: [0, 5]},
                {text: report.Procedimento.DESCRICAO, fontSize: 9, margin: [0, 5]},
                {text: report.Paciente.PLANO, fontSize: 9, margin: [0, 5]},
                {text: report.VALOR, fontSize: 9, margin: [0, 5]},
                
            ] 
        });
      
        const details = [
            {
                table:{
                    // Retorna o header em todas as páginas
                    headerRows: 1, 
                    widths: ['auto', 'auto', 180, 'auto', 80, 58, 'auto'],
                    body: [
                        // Cabeçalho da tabela
                        [
                          {text: 'Data', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Hora', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Nome', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Status', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Proced', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Plano', style: 'tableHeader', fontSize: 10, bold: true},
                          {text: 'Valor', style: 'tableHeader', fontSize: 10, bold: true},
                        ],
                        ...dados,
                        [
                          {text: '', colSpan: 5, border: [false, false, false, false]}, {}, {}, {}, {},
                          {text: 'Valor Total:',fontSize: 9, bold: true, margin: [0, 5]},
                          {text: parseInt(vt).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}), fontSize: 9, bold: true, margin: [0, 5]}
                          
                        ]
                      ]
                      
                   },
                layout: {
                    fillColor: function (rowIndex, node, columnIndex) {
                        if (rowIndex === 0) {
                          return '#f2f2f2';
                        } else {
                          return rowIndex % 2 === 0 ? '#ffffff' : '#f9f9f9'; 
                        }
                      },
                      hLineWidth: function (i, node) {
                        return 1;
                      },
                      vLineWidth: function (i, node) {
                        return 1;
                      },
                     
                     margin: [10, 0]
                  },
            }
        ];
      
        function Rodape(currentPage, pageCount){
          return [
              {
                  text: currentPage + ' / ' + pageCount,
                  alignment: 'right',
                  fontSize: 9,
                  margin: [0, 20, 20, 0], // left, top, right, bottom
              }
          ]
      }
      
      const docDefinitios = {
        pageSize: 'A4',
        pageMargins: [15, 20, 15, 50],
        content: [reportTitle, infoSub, infoDate, details],
        footer: Rodape,
        styles: {
            header: {
                fontSize: 25,
                margin: [0, 0],
                bold: true,
                alignment: 'center',
                width: '100%'
            },
            subheader: {
                fontSize: 12,
                margin: [0, 10],
                alignment: 'left',
                width: '100%'
            },
            tableHeader: {
                margin: [0, 5],
            }
        }
      }

      docDefinitios.defaultStyle = globalStyle;
      
      pdfMake.createPdf(docDefinitios).open();
      
    }
    
    // ----- LÓGICA E CONFIGURAÇÃO DOS GRÁFICOS -----
    const renderCharts = () => {
        if (!agenda || agenda.length === 0) return null;

        // --- DADOS PARA GRÁFICO DE BARRAS (AGENDAMENTOS POR DIA) ---
        const appointmentsByDateCounts = agenda.reduce((acc, item) => {
            const date = transformaData(item.DATA);
            acc[date] = (acc[date] || 0) + 1;
            return acc;
        }, {});

        const appointmentsByDateData = {
            labels: Object.keys(appointmentsByDateCounts),
            datasets: [{
                label: 'Nº de Agendamentos',
                data: Object.values(appointmentsByDateCounts),
                backgroundColor: 'rgba(54, 162, 235, 0.6)',
                borderColor: 'rgba(54, 162, 235, 1)',
                borderWidth: 1,
            }],
        };
        
        const barOptions = {
            responsive: true,
            plugins: {
                legend: { display: false },
                title: { display: true, text: 'Agendamentos por Dia' },
            },
            scales: { y: { beginAtZero: true, ticks: { precision: 0 } } },
        };


        // --- DADOS PARA GRÁFICO DE PIZZA (POR STATUS) ---
        const appointmentsByStatusCounts = agenda.reduce((acc, item) => {
            const status = item.Status.DESCRICAO || 'Não Definido';
            acc[status] = (acc[status] || 0) + 1;
            return acc;
        }, {});
        
        const appointmentsByStatusData = {
            labels: Object.keys(appointmentsByStatusCounts),
            datasets: [{
                data: Object.values(appointmentsByStatusCounts),
                backgroundColor: ['#10B981', '#3B82F6', '#F97316', '#EF4444', '#8B5CF6', '#F59E0B'],
                hoverBackgroundColor: ['#059669', '#2563EB', '#EA580C', '#DC2626', '#7C3AED', '#D97706'],
            }],
        };
        
        // --- DADOS PARA GRÁFICO DE PIZZA (POR PLANO) ---
        const appointmentsByPlanCounts = agenda.reduce((acc, item) => {
            const plan = item.Paciente.PLANO || 'Particular';
            acc[plan] = (acc[plan] || 0) + 1;
            return acc;
        }, {});

        const appointmentsByPlanData = {
            labels: Object.keys(appointmentsByPlanCounts),
            datasets: [{
                data: Object.values(appointmentsByPlanCounts),
                backgroundColor: ['#8B5CF6', '#EC4899', '#10B981', '#F59E0B', '#3B82F6', '#6B7280'],
                hoverBackgroundColor: ['#7C3AED', '#DB2777', '#059669', '#D97706', '#2563EB', '#4B5563'],
            }],
        };
        
        const pieOptions = (titleText) => ({
            responsive: true,
            maintainAspectRatio: false,
            plugins: {
                title: { display: true, text: titleText, font: {size: 16} },
                legend: {
                    position: 'right',
                    labels: {
                        generateLabels: (chart) => {
                            const { data } = chart;
                            if (!data.labels || !data.labels.length || !data.datasets.length) {
                                return [];
                            }
                            
                            const dataset = data.datasets[0];
                            const meta = chart.getDatasetMeta(0);
                            
                            return data.labels.map((label, i) => {
                                const style = meta.controller.getStyle(i);
                                const count = dataset.data[i];
                                
                                return {
                                    text: `${label}: ${count}`,
                                    fillStyle: style.backgroundColor,
                                    strokeStyle: style.borderColor,
                                    lineWidth: style.borderWidth,
                                    hidden: isNaN(count) || meta.data[i].hidden,
                                    index: i
                                };
                            });
                        }
                    }
                },
            },
        });

        return (
            <div style={{
                display: 'flex', 
                flexDirection: 'column', 
                gap: '2rem', 
                marginTop: '3rem', 
                paddingTop: '2rem', 
                borderTop: '1px solid #dee2e6' 
            }}>
                {/* Linha 1: Gráfico de Barras */}
                <div style={{ width: '100%', maxWidth: '900px', margin: '0 auto' }}>
                    <Bar options={barOptions} data={appointmentsByDateData} />
                </div>
                
                {/* Linha 2: Gráficos de Pizza */}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '2rem',
                    justifyContent: 'center',
                    alignItems: 'stretch'
                }}>
                    {opcao == 0 && (
                        <div style={{ flex: '1 1 350px', maxWidth: '500px', minWidth: '300px', height: '400px' }}>
                            <Pie options={pieOptions('Distribuição por Status')} data={appointmentsByStatusData} />
                        </div>
                    )}

                    <div style={{ flex: '1 1 350px', maxWidth: '500px', minWidth: '300px', height: '400px' }}>
                        <Pie options={pieOptions('Distribuição por Plano de Saúde')} data={appointmentsByPlanData} />
                    </div>
                </div>
            </div>
        );
    };

    return(
        <div>
            <div className="impAgenda-formContainer">
                <h2 className="impAgenda-title">Relatório de Agendamentos</h2>
                <form className='impAgenda-form '>
                    <div className="impAgenda-formGroup">
                        <label className="impAgenda-label">Selecione o Médico:</label>
                        <Form.Control size="sm" as="select" value={codMed} onChange={e => setCodMed(e.target.value)} >
                            {medicos.map( med => ( 
                            <option key={med.CODIGO} value={med.CODIGO}>{med.NOME}</option>
                            ))}
                        </Form.Control> 
                    </div>
                    <div className="impAgenda-formGroup ">
                        <label className="impAgenda-label">Opções de Status:</label>
                        <Form.Control size="sm" as="select" value={opcao} onChange={e => setOpcao(e.target.value)} >
                            <option value={0}>TODOS</option>
                            <option value={1}>AGUARDANDO</option>
                            <option value={2}>ATENDIDO</option>
                            <option value={3}>EM CONSULTA</option>
                            <option value={4}>MARCADO</option>
                            <option value={5}>NÃO COMPARECEU</option>
                            <option value={6}>DESMARCOU</option>
                        </Form.Control>
                    </div>
                    <div className="impAgenda-formGroup">
                        <label className="impAgenda-label">Data de:</label> 
                        <DatePicker                         
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Selecione Data"
                            selected={data1}
                            onChange={setData1}                            
                        /> 
                    </div>
                    <div className="impAgenda-formGroup">
                        <label className="impAgenda-label">Data até:</label> 
                        <DatePicker                         
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="Selecione Data"
                            selected={data2}
                            onChange={setData2}                             
                        /> 
                    </div>
                    <div className="impAgenda-formActions">
                        <Button variant="outline-primary" onClick={() => handleBuscaAgenda()} >Gerar</Button>
                        <Button variant="outline-primary" disabled={disableBtn}  onClick={ () => PrintReports(agenda)} >Imprimir</Button>
                    </div>
                </form>
                { agenda && agenda.length > 0 &&
                    <div ref={impAgenda}>
                    <br/>
                        <table className="table"  >
                                <thead>
                                    <tr>
                                        <th scope="col">Data</th>
                                        <th scope="col">Hora</th>
                                        <th scope="col">Nome</th>
                                        <th scope="col">Status</th>
                                        <th scope="col">Proced.</th>
                                        <th scope="col">Plano</th>
                                        <th scope="col">Valor</th>
                
                                    </tr>
                                </thead>
                                <tbody>
                                    {agenda.map(agendamento => ( // percorre todo o array e joga na tela em formato de tabela
                                        <tr key={agendamento.CODIGO}>
                                            <td>{transformaData(agendamento.DATA)}</td>
                                            <td>{agendamento.HORA}</td>
                                            <td>{agendamento.Paciente.NOME}</td>
                                            <td>{agendamento.Status.DESCRICAO}</td>
                                            <td>{agendamento.Procedimento.DESCRICAO}</td>
                                            <td>{agendamento.Paciente.PLANO || 'Particular'}</td>
                                            <td>{ agendamento.VALOR ? parseInt(agendamento.VALOR).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'}) : 'R$ 0,00'}</td>
                                        </tr>
                                        ))
                                        }
                                </tbody>
                        </table>
                        <div style={{ textAlign: 'right' }}><h5>Valor Total: {agenda.length > 0  && parseInt(valorTotal(agenda)).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'})}</h5> </div>
                        
                        {/* Renderiza a seção de gráficos */}
                        {renderCharts()}
                    </div>
                } 
            </div>
      
            <Modal show={modalMSG}>
                <Modal.Header> 
                    <h3>{MSG}</h3>
                </Modal.Header> 
                <Modal.Footer>
                    <Button variant="info" onClick={() => setModalMSG(false)}>Ok</Button>
                </Modal.Footer>
            </Modal> 
        </div>
    )
}